"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmrRadioButton = void 0;
// packages
const react_1 = __importStar(require("react"));
// styles
const RadioButton_styles_1 = require("./RadioButton.styles");
const SmrRadioButton = ({ disabled, elements, id = 'smr-radio-button', marginLeft, marginBottom, onChange, visible = true, }) => {
    const [radioButtonValue, setRadioButtonValue] = (0, react_1.useState)('');
    const handleOnChange = (event) => {
        if (!disabled) {
            setRadioButtonValue(event.target.value);
            onChange(event.target.value);
        }
    };
    const handleOnChangeFromLabel = (radioButtonId) => {
        var _a;
        const radioButtonValue = (_a = document.getElementById(radioButtonId)) === null || _a === void 0 ? void 0 : _a.nodeValue;
        if (radioButtonValue && !disabled) {
            setRadioButtonValue(radioButtonValue);
            onChange(radioButtonValue);
        }
    };
    if (!visible) {
        return null;
    }
    return (react_1.default.createElement(RadioButton_styles_1.StyledRadioButtonContainer, { id: `${id}-container` }, elements.length <= 4 &&
        elements.map((element, index) => {
            var _a;
            return (react_1.default.createElement(RadioButton_styles_1.StyledRadioButtonElement, { id: `${id}-element-${index}`, key: `${id}-${index}`, marginBottom: marginBottom },
                react_1.default.createElement(RadioButton_styles_1.StyledRadioButtonLabel, { disabled: (element === null || element === void 0 ? void 0 : element.disabled) || disabled, id: `${id}-label-${index}`, htmlFor: `${id}-radio-button-${index}`, marginLeft: marginLeft, onClick: () => handleOnChangeFromLabel(`${id}-radio-button-${index}`) },
                    react_1.default.createElement(RadioButton_styles_1.StyledRadioButton, { checked: (_a = element === null || element === void 0 ? void 0 : element.checked) !== null && _a !== void 0 ? _a : element.value === radioButtonValue, disabled: (element === null || element === void 0 ? void 0 : element.disabled) || disabled, id: `${id}-radio-button-${index}`, type: "radio", onChange: handleOnChange, style: { height: 18, margin: 0, width: 18 }, value: element.value }),
                    element.label)));
        })));
};
exports.SmrRadioButton = SmrRadioButton;
exports.default = exports.SmrRadioButton;
//# sourceMappingURL=RadioButton.js.map